import { render, staticRenderFns } from "./details-grouping.vue?vue&type=template&id=30a44359&scoped=true&"
import script from "./details-grouping.vue?vue&type=script&lang=js&"
export * from "./details-grouping.vue?vue&type=script&lang=js&"
import style0 from "./details-grouping.vue?vue&type=style&index=0&id=30a44359&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a44359",
  null
  
)

export default component.exports